// Centralized modal handlers using Foundation Reveal
export function attachAddressModalHandlers(
    modalId = 'address-modal',
) {
  const modalEl = document.getElementById(modalId);
  if (!modalEl) return;

  const editBtn = modalEl.querySelector('[data-action="edit-address"]');

  editBtn?.addEventListener('click', () => {
    // Close via vanilla pattern — Foundation may not be initialized yet at DOMContentLoaded
    const trigger = document.createElement('button');
    trigger.setAttribute('data-close', '');
    trigger.style.display = 'none';
    modalEl.appendChild(trigger);
    trigger.click();
    setTimeout(() => trigger.remove(), 100);
  });
}
